import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ContainerEffects } from 'app/state/containers/container.effects';

import { containerFeature } from './container.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(containerFeature), EffectsModule.forFeature([ContainerEffects])],
})
export class ContainerStateModule {}
